import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgEdit = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="M5 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 20v-2.425a1.98 1.98 0 0 1 .575-1.4L17.175 3.6q.3-.3.675-.45T18.6 3q.4 0 .762.15.363.15.638.45L21.4 5q.3.275.45.638a1.98 1.98 0 0 1 0 1.512q-.15.375-.45.675l-12.575 12.6a1.975 1.975 0 0 1-1.4.575zm1-2h1.4l9.825-9.8-.7-.725-.725-.7L6 17.6zM16.525 8.475l-.725-.7L17.225 9.2zM14 21a6.64 6.64 0 0 0 3.425-.925Q19 19.15 19 17.5q0-.9-.475-1.55-.476-.65-1.275-1.125L15.775 16.3q.575.25.9.55t.325.65q0 .575-.913 1.038Q15.175 19 14 19a.97.97 0 0 0-.713.288A.97.97 0 0 0 13 20q0 .424.287.712.288.288.713.288m-9.425-7.65 1.5-1.5a3.6 3.6 0 0 1-.788-.412Q5 11.225 5 11q0-.3.45-.6t1.9-.925q2.2-.95 2.925-1.725T11 6q0-1.375-1.1-2.187Q8.8 3 7 3q-1.124 0-2.013.4-.886.4-1.362.975A.9.9 0 0 0 3.4 5.1a.94.94 0 0 0 .375.65.9.9 0 0 0 .725.225q.4-.05.675-.325.35-.35.775-.5T7 5q1.025 0 1.512.3T9 6q0 .35-.437.638-.438.287-2.013 1.012-2 .874-2.775 1.588A2.3 2.3 0 0 0 3 11q0 .8.425 1.363t1.15.987"
      />
    </Svg>
  );
};
export default SvgEdit;
